import { CookieKey, removeCookie } from 'mt-shared';
import { getDomain } from './url';

export const cookieDomain: string = `.${getDomain()}`;
export const cookiePath: string = '/';

export function removeAuthToken(): void {
  // remove cookie set from domain
  removeCookie(CookieKey.AUTH_TOKEN, { path: cookiePath, domain: cookieDomain });

  // remove cookie set from web
  removeCookie(CookieKey.AUTH_TOKEN, { path: cookiePath });

  // remove sendbird token
  removeCookie(CookieKey.SENDBIRD_AUTH_TOKEN, { path: cookiePath });
}

function clearDemoModeSession(): void {
  const demoModeCookieKeys: CookieKey[] = [CookieKey.REMOTE_LOGIN_TOKEN, CookieKey.DEMO_USER, CookieKey.DEMO_SESSION];

  demoModeCookieKeys.forEach((cookieKey: CookieKey) => {
    removeCookie(cookieKey, { path: cookiePath, domain: cookieDomain });
    removeCookie(cookieKey, { path: cookiePath });
  });
}

function clearSupportModeSession(): void {
  const supportModeCookieKeys: CookieKey[] = [CookieKey.REMOTE_LOGIN_TOKEN, CookieKey.SUPPORT_USER, CookieKey.SUPPORT_SESSION];

  supportModeCookieKeys.forEach((cookieKey: CookieKey) => {
    removeCookie(cookieKey, { path: cookiePath, domain: cookieDomain });
    removeCookie(cookieKey, { path: cookiePath });
  });
}

function clearReadOnlyModeSession(): void {
  const readOnlyModeCookieKeys: CookieKey[] = [CookieKey.READ_ONLY_MODE];

  readOnlyModeCookieKeys.forEach((cookieKey: CookieKey) => {
    removeCookie(cookieKey, { path: cookiePath, domain: cookieDomain });
    removeCookie(cookieKey, { path: cookiePath });
  });
}

export function clearDashboardStorage(): void {
  removeCookie(CookieKey.DASHBOARD_STORAGE);
}

export function clearAllCookies() {
  removeAuthToken();
  clearDemoModeSession();
  clearSupportModeSession();
  clearReadOnlyModeSession();
}
